import { TypographyComponent } from "@tvg/fuse-typography-element";
import React from "react";
import styled from "styled-components";

export interface SectionTitleProps {
  dataTestId: string;
  id?: string;
}

const StyledTypographyElement = styled(TypographyComponent)`
  margin-bottom: 0;
`;

const SectionTitle: React.FC<SectionTitleProps> = (
  props: SectionTitleProps,
) => {
  return (
    <StyledTypographyElement
      tag="div"
      type="paragraph"
      size="m1"
      color="var(--color-greys-grey9)"
      {...props}
    />
  );
};
export default SectionTitle;
